import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack';
import Draggable from 'react-draggable';
import Grid from '@mui/material/Grid';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import { BorderLinearProgress } from './CustomProgressbars';
import { Close, CloseFullscreenRounded, OpenInFullRounded } from '@mui/icons-material';


function TransferWindow({ children }) {
    const [draggableWindow, setDraggableWindow] = React.useState(false);
    const [minimize, setMinimize] = React.useState(false);

    // React.useEffect(() => {
    //     const timer = setInterval(() => {
    //         setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    //     }, 800);
    //     return () => {
    //         clearInterval(timer);
    //     };
    // }, []);


    const isBackgroundTaskOpen = useSelector(({
        utilities: { isBackgroundTaskOpen }
    }) => (isBackgroundTaskOpen));
    const openWindow = React.useCallback(() => {
        return isBackgroundTaskOpen
    }, [isBackgroundTaskOpen])

    const pendingTasks = useSelector(state => state.utilities.pendingTasks)
    const totalTasks = useSelector(state => state.utilities.totalTasks)
    const completeTasks = useSelector(state => state.utilities.completeTasks)
    const failedTasks = useSelector(state => state.utilities.failedTasks)

    const getProgress = React.useCallback(() => {
        const percentage = totalTasks > 0 ? (completeTasks / totalTasks) * 100 : 0;
        return percentage;
    }, [completeTasks, totalTasks])
    const dispatch = useDispatch();

    const activeTasks = Math.max(pendingTasks - failedTasks, 0);


    const setDrag = () => {
        if (!draggableWindow) {
            setDraggableWindow(true);
        }
    }
    const unSetDrag = () => {
        if (draggableWindow) {
            setDraggableWindow(false)
        }

    }
    const childrenWithProps = React.Children.map(children, child => {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        return React.cloneElement(child, { setDrag, unSetDrag });

    });

    return (
        <Draggable
            disabled={draggableWindow}
            bounds="html"
        >
            <Box sx={{
                overflowY: "none",
                overscrollBehavior: "contain",
                bgcolor: '#0f172a',
                border: '1px solid rgba(148, 163, 184, 0.24)',
                borderRadius: '14px',
                minHeight: openWindow() ? minimize ? "35px" : '400px' : 0,
                maxHeight: openWindow() ? minimize ? "35px" : 'max-content' : 0,
                transition: "opacity .15s ease-out",
                opacity: openWindow() ? 1 : 0,
                overflow: openWindow() ? 'auto' : "hidden",
                minWidth: "400px",
                width: openWindow() ? '400px' : 0,
                resize: 'both',
                position: 'absolute',
                bottom: 100,
                right: 100,
                padding: 0,
                boxShadow: '0 20px 45px rgba(2, 6, 23, 0.45)',
                zIndex: 100000,
                pb: minimize ? 0 : 1
            }} direction='vertical'>
                <Stack direction='column' sx={{ minWidth: '100%' }}>
                    <Grid container
                        sx={{
                            pl: 2,
                            pr: 1,
                            pt: .75,
                            width: '100%',
                            bgcolor: 'rgba(15, 23, 42, 0.96)',
                            borderBottom: minimize ? 'none' : '1px solid rgba(148, 163, 184, 0.18)',
                            borderTopLeftRadius: '14px',
                            borderTopRightRadius: '14px',
                            pb: minimize ? .4 : 1.2
                        }}
                        direction="row"
                    >
                        <Grid item xs={4} sx={{ mt: minimize ? .5 : 1 }}>
                            <Badge color='error'
                                badgeContent={failedTasks}
                                sx={{
                                    "& .MuiBadge-badge": {
                                        width: minimize ? 15 : 20,
                                        height: minimize ? 15 : 20,
                                        fontSize: 10
                                    }
                                }}
                            >
                                <Typography
                                    variant={minimize ? 'body2' : 'body2'}
                                    noWrap
                                    sx={{
                                        fontFamily: 'quicksand',
                                        flexGrow: 1,
                                        color: '#f8fafc',
                                        fontWeight: 700,
                                        letterSpacing: '.01em'
                                    }}
                                >
                                    Background Tasks
                                </Typography>
                            </Badge>
                        </Grid>
                        <Grid item xs={6} sx={{ mt: minimize ? 1 : 1.5 }}>
                            {pendingTasks > 0 && (
                                <BorderLinearProgress
                                    progressHeight={minimize ? 3 : 5}
                                    progressBorderRadius={minimize ? 3 : 999}
                                    value={getProgress()}
                                    textColor="#e2e8f0"
                                />)
                            }
                        </Grid>
                        <Grid item xs={2} sx={{ paddingTop: minimize ? .1 : .5, paddingLeft: 1 }}
                        >
                            <Stack direction="row" justifyContent="flex-end" spacing={1}>
                                <IconButton
                                    edge="end"
                                    aria-label="minimize"
                                    aria-controls="1"
                                    aria-haspopup="true"
                                    onClick={() => setMinimize(!minimize)}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            width: minimize ? '.6em' : '.8em',
                                            height: '.8em',
                                            color: '#e2e8f0'
                                        }
                                    }}
                                >
                                    {minimize ? <OpenInFullRounded /> : <CloseFullscreenRounded />}
                                </IconButton>
                                <IconButton
                                    edge="end"
                                    aria-label="minimize"
                                    aria-controls="1"
                                    aria-haspopup="true"
                                    onClick={() => dispatch({ type: 'CLOSE_BACKGROUND_TASK_MODAL' })}
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            width: minimize ? '.6em' : '.8em',
                                            height: '.8em',
                                        }
                                    }}
                                    color='error'
                                >
                                    <Close />
                                </IconButton>
                            </Stack>
                        </Grid>
                    </Grid>
                    {!minimize && (
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                px: 2,
                                pt: 1.25,
                                pb: 1,
                                flexWrap: 'wrap',
                                gap: 1,
                                bgcolor: 'rgba(15, 23, 42, 0.9)',
                                borderBottom: '1px solid rgba(148, 163, 184, 0.12)'
                            }}
                        >
                            <Chip
                                label={`${pendingTasks} total`}
                                size="small"
                                sx={{
                                    bgcolor: 'rgba(148, 163, 184, 0.16)',
                                    color: '#e2e8f0',
                                    fontWeight: 700
                                }}
                            />
                            <Chip
                                label={`${activeTasks} active`}
                                size="small"
                                sx={{
                                    bgcolor: 'rgba(37, 99, 235, 0.22)',
                                    color: '#bfdbfe',
                                    fontWeight: 700
                                }}
                            />
                            <Chip
                                label={`${completeTasks} done`}
                                size="small"
                                sx={{
                                    bgcolor: 'rgba(22, 163, 74, 0.22)',
                                    color: '#bbf7d0',
                                    fontWeight: 700
                                }}
                            />
                            <Chip
                                label={`${failedTasks} failed`}
                                size="small"
                                sx={{
                                    bgcolor: 'rgba(220, 38, 38, 0.22)',
                                    color: '#fecaca',
                                    fontWeight: 700
                                }}
                            />
                        </Stack>
                    )}
                    <Box display={minimize ? 'none' : 'inherit'} sx={{ bgcolor: 'rgba(15, 23, 42, 0.82)' }}>
                        {childrenWithProps}
                    </Box>
                </Stack>
            </Box>
        </Draggable >
    )
}

export default TransferWindow
